module.exports = __webpack_public_path__ + "img/5.efb7228e.png";